import { SVGAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

export const GalleryIcon = ({ className, ...props }: SVGAttributes<SVGElement>) => (
  <svg
    data-cy="gallery-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 22"
    fill="none"
    className={twMerge('h-5 w-5 stroke-current', className)}
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.7"
      d="M6.9 20.4h14.5c1 0 1.7-.7 1.7-1.7V7.6c0-1-.7-1.7-1.7-1.7H7c-1 0-1.8.7-1.8 1.7v11.1c0 1 .8 1.7 1.8 1.7Z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.7"
      d="M.9 16.1V3.3a1.7 1.7 0 0 1 1.7-1.7H18M6.2 20.3l6.7-7.1a1.7 1.7 0 0 1 2.5 0l6.8 7"
    />
  </svg>
)
